import { render } from "./TemplateCollections.vue?vue&type=template&id=62fb3d2c&scoped=true"
import script from "./TemplateCollections.vue?vue&type=script&lang=js"
export * from "./TemplateCollections.vue?vue&type=script&lang=js"

import "./frameTemplateCollections.scss?vue&type=style&index=0&id=62fb3d2c&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62fb3d2c"]])

export default __exports__